// Provider-agnostic analytics event layer. No cookies, no external scripts.
// Connect GA4 / Plausible / others later via registerAnalyticsProvider().
export const EVENTS = {
  PAGE_VIEW: "page_view",
  CTA_CLICK: "cta_click",
  CONTACT_FORM_STARTED: "contact_form_started",
  CONTACT_FORM_SUBMITTED: "contact_form_submitted",
  PRODUCT_VIEWED: "product_viewed",
  SERVICE_VIEWED: "service_viewed",
  LANGUAGE_CHANGED: "language_changed",
  OUTBOUND_LINK_CLICKED: "outbound_link_clicked",
};

const providers = [];

export function registerAnalyticsProvider(fn) {
  if (typeof fn === "function") providers.push(fn);
}

export function track(event, props = {}) {
  const payload = {
    event,
    path: window.location.pathname,
    lang: document.documentElement.lang || "en",
    ts: new Date().toISOString(),
    ...props,
  };
  window.__epEvents = (window.__epEvents || []).slice(-199);
  window.__epEvents.push(payload);
  providers.forEach((p) => { try { p(payload); } catch { /* provider errors never break UX */ } });
}
